<template>
  <div class="card">
    <Toast />
    <div class="title">Daftar Mutasi Harga</div>

    <DataTable
      :value="mutations"
      :lazy="true"
      :paginator="true"
      :rows="limit"
      :totalRecords="total_records"
      :loading="loading"
      @page="onPageChange($event)"
    >
      <template #header>
        <div class="p-grid p-fluid">
          <!-- Filter Inputs Row -->
          <div class="p-col-12 p-md-3 p-lg-3">
            <label for="doc-number" class="block mb-1">Nomor Bon</label>
            <InputText
              id="doc-number"
              v-model="filter.doc_number"
              placeholder="Masukkan nomor bon"
              class="w-100"
            />
          </div>
          <div class="p-col-12 p-md-3 p-lg-3">
            <label for="doc-date" class="block mb-1">Tanggal Bon</label>
            <Calendar
              id="doc-date"
              v-model="filter.doc_date"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              placeholder="Pilih tanggal bon"
              class="w-100"
            />
          </div>

          <!-- Filter Buttons Row -->
          <div class="p-col-12 p-md-3 p-lg-3 p-d-flex p-ai-end">
            <Button
              label="Cari"
              icon="pi pi-search"
              class="p-button-info p-mr-2"
              @click="getMutations()"
              :loading="loading"
              v-shortkey="['enter']"
              @shortkey="getMutations()"
            />
            <Button
              label="Reset"
              icon="pi pi-refresh"
              class="p-button-secondary"
              @click="confirmReset"
              :disabled="loading"
            />
          </div>
        </div>
      </template>

      <template #empty>
        <div class="empty-state">
          <i class="pi pi-inbox mb-3" style="font-size: 2rem"></i>
          <p>Data tidak ditemukan</p>
          <small class="p-text-secondary"
            >Silakan coba dengan filter yang berbeda</small
          >
        </div>
      </template>

      <Column header="Tipe Mutasi">
        <template #body="slotProps">
          {{ slotProps.data.type }}
        </template>
      </Column>
      <Column header="Nomor Bon">
        <template #body="slotProps">
          {{ slotProps.data.doc_number }}
        </template>
      </Column>
      <Column header="Tanggal Bon">
        <template #body="slotProps">
          {{ slotProps.data.doc_date }}
        </template>
      </Column>
      <Column headerStyle="width: 5em">
        <template #body="slotProps">
          <div>
            <router-link
              :to="{
                name: 'price-mutation-detail',
                query: { doc_number: slotProps.data.doc_number }
              }"
            >
              <Button
                icon="pi pi-eye"
                class="p-button-rounded p-button-success"
              ></Button>
            </router-link>
          </div>
        </template>
      </Column>
    </DataTable>

    <!-- Reset Confirmation Dialog -->
    <Dialog
      :visible.sync="resetDialog"
      :style="{ width: '450px' }"
      header="Konfirmasi Reset"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Apakah Anda yakin ingin mereset semua filter?</span>
      </div>
      <template #footer>
        <Button
          label="Batal"
          icon="pi pi-times"
          class="p-button-text"
          @click="resetDialog = false"
        />
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-secondary"
          @click="resetFilters"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
var moment = require('moment')

export default {
  data() {
    return {
      moment: moment,
      loading: false,
      resetDialog: false,
      filter: {
        doc_number: '',
        doc_date: ''
      },
      mutations: [],
      limit: 10,
      offset: 0,
      total_records: 0
    }
  },
  mounted() {
    this.getMutations()
  },
  methods: {
    onPageChange(event) {
      this.offset = event.first
      this.getMutations()
    },
    getMutations() {
      if (this.loading) return

      let type = 'PRICE_MUTATION'

      let doc_date = this.filter.doc_date
        ? moment(this.filter.doc_date).format('YYYY-MM-DD')
        : ''

      this.loading = true
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/mutations?doc_number=${this.filter.doc_number}&doc_date=${doc_date}&type=${type}&limit=${this.limit}&offset=${this.offset}&order_by=-created_at`
        )
        .then(response => {
          if (response.status === 200) {
            this.mutations = response.data.data.mutations
            this.total_records = response.data.data.total
          }
        })
        .catch(error => {
          if (error.response && error.response.status !== 401) {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Gagal mengambil data mutasi. Silakan coba lagi.',
              life: 3000
            })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    confirmReset() {
      this.resetDialog = true
    },
    resetFilters() {
      this.filter = {
        doc_number: '',
        doc_date: ''
      }
      this.resetDialog = false
      this.getMutations()
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 2px 1px -1px rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 1px 3px 0 rgba(0, 0, 0, 0.12);
  padding: 1.5rem;

  .title {
    font-size: 1.5rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1.5rem;
  }
}

.block {
  display: block;
}

.mb-1 {
  margin-bottom: 0.5rem;
}

.w-100 {
  width: 100%;
}

.empty-state {
  text-align: center;
  padding: 2rem;
  color: #6c757d;

  i {
    color: #2196f3;
    margin-bottom: 1rem;
  }

  p {
    margin-bottom: 0.5rem;
    font-size: 1rem;
  }

  small {
    font-size: 0.875rem;
  }
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  i {
    color: #f44336;
    margin-right: 1rem;
  }
}

:deep(.p-datatable) {
  .p-datatable-thead > tr > th {
    background-color: #f8f9fa;
    padding: 0.75rem;
    font-size: 0.875rem;
    font-weight: 600;
    color: #495057;
  }

  .p-datatable-tbody > tr > td {
    padding: 0.75rem;
    font-size: 0.875rem;
  }

  .p-datatable-tbody > tr:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }
}
</style>
